import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=6361bd7e&scoped=true&"
import script from "./HelpCenter.vue?vue&type=script&lang=js&"
export * from "./HelpCenter.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HelpCenter.vue?vue&type=style&index=1&id=6361bd7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6361bd7e",
  null
  
)

export default component.exports